import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PWAProvider } from "./context/PWAProvider.tsx";
import * as Sentry from "@sentry/react";

import "./index.css";
import App from "./App.tsx";

Sentry.init({
    // Data Source Name - unique identifier for your Sentry project to route events
    dsn: "https://de0b346cdd8e26188500269b34b50992@o4510101556822016.ingest.de.sentry.io/4510104327946320",

    // Include personally identifiable information (IP addresses, user data) in error reports
    // Helps with debugging but consider privacy implications
    sendDefaultPii: true,

    // Core Sentry integrations for React applications
    integrations: [
        Sentry.browserTracingIntegration(), // Tracks page loads, navigation, and API calls
        Sentry.replayIntegration(), // Records user sessions for debugging
        // Sentry.feedbackIntegration({
        //     // Additional SDK configuration goes in here, for example:
        //     colorScheme: "system",
        // }),
        Sentry.feedbackIntegration({
            // Disable the injection of the default widget
            autoInject: false,
        }),
    ],

    // Performance monitoring - percentage of transactions to trace (0.0 to 1.0)
    // 1.0 = 100% of transactions tracked (use lower values in production)
    tracesSampleRate: 1.0,

    // URLs where distributed tracing headers (sentry-trace, baggage) should be added
    // Enables connecting frontend errors to backend traces - disabled due to CORS issues
    // tracePropagationTargets: [...],

    // Session replay sampling - percentage of normal sessions to record (0.0 to 1.0)
    // 0.1 = 10% of sessions recorded for performance analysis
    replaysSessionSampleRate: 0.1,

    // Session replay on errors - percentage of error sessions to record (0.0 to 1.0)
    // 1.0 = 100% of sessions with errors are recorded for debugging
    replaysOnErrorSampleRate: 1.0,

    // Capture console logs and send them to Sentry for additional debugging context
    enableLogs: true,
});

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <PWAProvider>
            <App />
        </PWAProvider>
    </StrictMode>
);
